const styles = {
  typeTransfert: {
    display: "flex",
    gap: "16px",
  },
};

export default styles;
